import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Zendesk.svg",
  "use": "Zendesk.svg-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol viewBox=\"0 0 128 128\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Zendesk.svg\"><path d=\"m60.0403222 45.6023342v57.3976658h-48.0403222zm0-20.6023342c0 13.128223-10.7541924 23.7707505-24.0201611 23.7707505s-24.0201611-10.6425275-24.0201611-23.7707505zm7.9142165 78c0-13.128223 10.7541924-23.7707505 24.0201611-23.7707505 13.2659682 0 24.0201612 10.6425275 24.0201612 23.7707505zm0-20.6023342v-57.3976658h48.0454613z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol